<template>
    <section class="administration-userlog">
        <div>
            <div class="grid-x align-items userlog-actions">
                <div class="section-header">
                    Log (max 500)
                    <span title="Genindlæs listen"><icon class="small-svg fill-dark-gray userlog-refresh" name="reload" @click="refreshLog"/></span>
                </div>
                <div class="auto cell align-items flexbox-end">
                    <div style="display: flex; gap: 1rem;">
                        <div class="userlog-filter">
                            <label for="organization_select">Virksomhed</label>
                            <select v-model="filter.organizationId" @change="updateOrganization()" id="organization_select">
                                <option v-for="(company, index) in companyListSorted" :key="index" :value="company.id">{{ company.name }}</option>
                            </select>
                            <icon v-if="filter.organizationId" class="clear-select small-svg" name="clear" title="Fjern virksomhed" @click="clearFilter('organizationId')" />
                        </div>
                        <div class="userlog-filter">
                            <label for="user_select">Bruger</label>
                            <select v-model="filter.userId" @change="getLog()" id="user_select" :disabled="!filter.organizationId" :title="!filter.organizationId ? 'Vælg en virksomhed' : null">
                                <option v-for="(user, index) in employeeListSorted" :key="index" :value="user.userId">{{ user.name }}</option>
                            </select>
                            <icon v-if="filter.organizationId && filter.userId" class="clear-select small-svg" name="clear" title="Fjern bruger" @click="clearFilter('userId')" />
                        </div>
                        <div>
                            <label>Efter dato</label>
                            <div class="calendar-input">
                                <date-picker
                                    name="dateFrom"
                                    id="userlog-from"
                                    language="da"
                                    wrapper-class="vdp-datepicker--right"
                                    :monday-first="true"
                                    ref="userLogFrom"
                                    :format="formatDateDatePicker"
                                    v-model="filter.fromDateTime"
                                    @input="setDate('fromDateTime')"
                                />
                                <icon v-if="filter.fromDateTime" class="clear small-svg" name="clear" title="Fjern dato" @click="clearFilter('fromDateTime')" />
                                <icon class="calendar small-svg" name="calendar" />
                            </div>
                        </div>
                        <div>
                            <label>Til dato</label>
                            <div class="calendar-input">
                                <date-picker
                                    name="dateTo"
                                    id="userlog-to"
                                    language="da"
                                    wrapper-class="vdp-datepicker--right"
                                    :monday-first="true"
                                    ref="userLogTo"
                                    :format="formatDateDatePicker"
                                    v-model="filter.toDateTime"
                                    @input="setDate('toDateTime')"
                                />
                                <icon v-if="filter.toDateTime" class="clear small-svg" name="clear" title="Fjern dato" @click="clearFilter('toDateTime')" />
                                <icon class="calendar small-svg" name="calendar" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="userLog.length > 0" class="grid-x">
                <div class="cell large-12">
                    <div class="grid-x list-sort">
                        <div class="cell large-2 item flexbox" @click="sort('logDateTime')" :class="{selected: currentSort === 'logDateTime'}">
                            <span>Tidspunkt</span>
                            <div>
                                <icon v-if="currentSort === 'logDateTime'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'logDateTime'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                        <div class="cell large-2 item flexbox" @click="sort('username')" :class="{selected: currentSort === 'username'}">
                            <span>Bruger</span>
                            <div>
                                <icon v-if="currentSort === 'username'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'username'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                       <div class="cell large-2 item flexbox" @click="sort('userOrganization')" :class="{selected: currentSort === 'userOrganization'}">
                            <span>Virksomhed</span>
                            <div>
                                <icon v-if="currentSort === 'userOrganization'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'userOrganization'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                        <div class="cell large-2 item flexbox" @click="sort('email')" :class="{selected: currentSort === 'email'}">
                            <span>E-mail</span>
                            <div>
                                <icon v-if="currentSort === 'email'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'email'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                        <div class="cell large-2 item flexbox-start sort-status-tag" @click="sort('phoneNumber')" :class="{selected: currentSort === 'phoneNumber'}">
                            <span>Telefonnr.</span>
                            <div>
                                <icon v-if="currentSort === 'phoneNumber'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'phoneNumber'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                        <div class="cell large-2 item flexbox-start sort-status-tag" @click="sort('application')" :class="{selected: currentSort === 'application'}">
                            <span>Applikation</span>
                            <div>
                                <icon v-if="currentSort === 'application'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'application'}" name="keyboard_arrow_sort" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <p>Der er intet at vise</p>
            </div>
            <transition-group name="list" tag="div" class="userlog-list">
                <div v-for="(log, index) in paginatedUserLog" :key="index" class="userlog-list-row">
                    <div class="cell large-12">
                        <div class="grid-x list-row align-items">
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.logDateTime | formatDateTime}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.name}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.userOrganization}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.username}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.phoneNumber}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span class="truncate-ellipse">{{log.application}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
            <div class="pagination" v-if="sortedUserLog.length">
                <button :disabled="currentPage === 1" @click="currentPage--">Forrige</button>
                <button v-for="page in paginationButtons" :key="page" @click="page !== '...' && (currentPage = page)" :class="{ 'active': page === currentPage }">
                  {{ page }}
                </button>
                <button :disabled="currentPage === totalPages" @click="currentPage++">Næste</button>
              </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'

export default {
    components: {
        'date-picker': Datepicker
    },
    data () {
        return {
            userLog: [],
            currentSort: 'logDateTime',
            currentSortDir: 'desc',
            filter: {
                fromDateTime: null,
                toDateTime: null,
                organizationId: null,
                userId: null
            },
            currentPage: 1,
            itemsPerPage: 50
        }
    },
    computed: {
        ...mapGetters({
            companyEmployeeList: 'getOrganizationEmployeeList',
            companies: 'getAssociatedOrganizationList',
            applicationList: 'getApplicationList'
        }),
        companyListSorted () {
            return this.companies.sort((a, b) => a.name.localeCompare(b.name))
        },
        employeeListSorted () {
            if (this.companyEmployeeList && this.companyEmployeeList.length > 0) {
                return this.companyEmployeeList.sort((a, b) => a.name.localeCompare(b.name))
            } else {
                return []
            }
        },
        sortedUserLog () {
            if (this.userLog && this.userLog.length > 0) {
                return this.userLog.sort((a, b) => {
                    let modifier = 1
                    if (this.currentSortDir === 'desc') {
                        modifier = -1
                    }
                    if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase() || a[this.currentSort] === null) {
                        return -1 * modifier
                    }
                    if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase() || b[this.currentSort] === null) {
                        return 1 * modifier
                    }
                    return 0
                })
            } else {
                return []
            }
        },
        paginatedUserLog () {
            const start = (this.currentPage - 1) * this.itemsPerPage
            const end = start + this.itemsPerPage
            return this.sortedUserLog.slice(start, end)
        },
        totalPages () {
            return Math.ceil(this.sortedUserLog.length / this.itemsPerPage)
        },
        paginationButtons () {
            const pages = []
            for (let i = 1; i <= this.totalPages; i++) {
                // Only add first, last, current, previous, next, and two on either side of current page
                if (i === 1 || i === this.totalPages || (i >= this.currentPage - 1 && i <= this.currentPage + 1)) {
                    pages.push(i)
                } else if (i === this.currentPage - 2 || i === this.currentPage + 2) {
                    pages.push('...')
                }
            }
            return pages
        }
    },
    methods: {
        ...mapActions({
            getUserLog: 'getUserLog',
            setOrganizationEmployeeList: 'setOrganizationEmployeeList',
            setApplication: 'setApplication',
            setAllCodeLists: 'setAllCodeLists',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive'
        }),
        sort (s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = s
        },
        updateOrganization () {
            this.filter.userId = null
            this.setOrganizationEmployeeList(this.filter.organizationId)
            this.getLog()
        },
        getLog () {
            this.getUserLog(this.filter).then((response) => {
                this.userLog = response.model
            })
        },
        refreshLog () {
            this.userLog = []
            this.getLog()
        },
        setDate (dateFilter) {
            let timeArray = [0, 0, 0, 0]
            if (dateFilter === 'toDateTime') {
                timeArray = [23, 59, 59, 999]
            }
            this.filter[dateFilter].setHours(...timeArray)
            this.getLog()
        },
        formatDateDatePicker (date) {
            if (date) {
                return this.$filters.formatDateShort(date)
            } else {
                return ''
            }
        },
        clearFilter (filter) {
            this.filter[filter] = null
            if (filter === 'organizationId') {
                this.filter.userId = null
            }
            this.getLog()
        }
    },
    created () {
        if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
            new Promise((resolve, reject) => {
                resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
            }).then(() => {
                this.setAllCodeLists()
                this.setApplicationSettingsDrive()
            })
        }
        this.getLog()
    }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/pages/administration/drive/administration-userlog.vue